export default "__VITE_ASSET__BvSp3vx2__"